<template>
  <div class="tojoin-write">
    <div class="banner">
      <img class="bannerImg" src="~@/assets/img/test-drive/banner.jpg" alt="">
    </div>
    <div class="content">
      <!-- 大标题 -->
      <div class="title">
        <second-title 
          englithTitle="erchants to join"
          englithA="M"
          changname="片区招商"
          addone="试乘试驾"
          addtow="片区招商"
        ></second-title>
      </div>
      <div class="write-form-box">
        <el-form ref="form" :model="form" :rules="rules">
          <!-- 第1行 -->
          <el-row :gutter="150">
            <!-- 省份选择 -->
            <el-col :span="8">
              <el-form-item class="province" prop="provinceId">
                <div class="title-box">
                  <label class="text-1">省份选择</label>
                  <label class="text-2">Province</label>
                </div>
                <el-select v-model="form.provinceId" placeholder="请选择省份" @change="changeVal(form.provinceId)">
                  <el-option v-for="(item,idx) in provinceList" :key="idx" :label="item.area_name" :value="item.area_id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 地区选择 -->
            <el-col :span="8">
              <el-form-item class="region" prop="cityId">
                <div class="title-box">
                  <label class="text-1">地区选择</label>
                  <label class="text-2">Region</label>
                </div>
                <el-cascader
                  v-model="form.cityId"
                  :options="regionList"
                  :props="props"
                  :key="cascaderKey"
                  :disabled="isDisabled"
                  >
                </el-cascader>
              </el-form-item>
            </el-col>
            <!-- 电子邮箱 -->
            <el-col :span="8">
              <el-form-item class="email" prop="email">
                <div class="title-box">
                  <label class="text-1">电子邮箱</label>
                  <label class="text-2">E-Mail</label>
                </div>
                <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第2行 -->
          <el-row :gutter="150">
            <!-- 申请人姓名 -->
            <el-col :span="8">
              <el-form-item class="name" prop="contactsName">
                <div class="title-box">
                  <label class="text-1">申请人姓名</label>
                  <label class="text-2">Name</label>
                </div>
                <el-input v-model="form.contactsName" placeholder="请输入姓名"></el-input>
              </el-form-item>
            </el-col>
            <!-- 手机号码 -->
            <el-col :span="8">
              <el-form-item class="phoneNumber" prop="contactsPhone">
                <div class="title-box">
                  <label class="text-1">手机号码</label>
                  <label class="text-2">Phone Number</label>
                </div>
                <el-input v-model="form.contactsPhone" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 详细地址 -->
          <el-row :gutter="150">
            <el-col :span="24">
              <el-form-item class="address" prop="companyAddressDetail">
                <div class="title-box">
                  <label class="text-1">详细地址</label>
                  <label class="text-2">Address</label>
                </div>
                <el-input v-model="form.companyAddressDetail" placeholder="请输入详细地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 经营优势 -->
          <el-row :gutter="150">
            <el-col :span="24">
              <el-form-item class="business" prop="businessAdvantages">
                <div class="title-box">
                  <label class="text-1">经营优势</label>
                  <label class="text-2">Business</label>
                </div>
                <el-input v-model="form.businessAdvantages" type="textarea" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 提交 -->
      <div class="btn">
        <el-button type="primary" @click="onSubmit('form')" round>提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import SecondTitle from '@/components/SecondTitle.vue'
import { getAreaListApi, attractInvestmentApi } from "../../../../../request/api";
export default {
  components:{
    SecondTitle,
  },
  data(){
    return{
      form: {
        areaId:null, //片区ID 新增传null
        provinceId: '', //省id
        cityId: '', //市id
        countryId:'', //区id
        email: '', //邮箱
        contactsName: '', //姓名 
        contactsPhone: '', //手机号
        companyAddressDetail: '', //详细地址
        businessAdvantages: '', //经营优势
        province:'', //省
        city:'', //市
        country:'', //区
      },
      rules:{
        provinceId: [
            { required: true, message: '请选择省份', trigger: 'blur' },
        ],
        cityId: [
            { required: true, message: '请选择市区', trigger: 'blur' },
        ],
        email: [
            { required: true, message: '请输入邮箱', trigger: 'blur' },
        ],
        contactsName: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        contactsPhone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        companyAddressDetail: [
            { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        businessAdvantages: [
            { required: true, message: '请输入经营优势', trigger: 'blur' },
        ],
        
      },
      isDisabled:true, //省未选择时，市区选择为不可选
      provinceList:[], //省选择列表
      regionList:[], //市区列表
      props:{value:'area_id',label:'area_name'}, //自定义级联选择属性名
      cascaderKey:1 //定义一个key 防止切换数据源时控制台报错
    }
  },
  created(){
    this.getAreaListApi()
  },
  methods:{
    // 省市区数据请求
    getAreaListApi(){
      const datas = {
        m:'Mobile',
        c:'Area',
        a:'get_tree_list'
      }
      getAreaListApi(datas).then(({data})=>{
        this.provinceList = data.data
      })
    },
    // 省份切换时，赋值市区
    changeVal(val){
      this.isDisabled = false
      ++this.cascaderKey
      this.provinceList.forEach((item,idx) => {
          if (val == item.area_id) {
            this.regionList = item.children
            this.form.province = item.area_name
          }
        });
    },
    // 表格提交
    onSubmit(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            this.form.countryId = this.form.cityId[1]
            this.form.cityId = this.form.cityId[0]
            this.regionList.forEach((item,idx) => {
              if (this.form.cityId==item.area_id) {
                this.form.city = item.area_name
                if (item.children&&item.children.length>0) {
                  item.children.forEach((item1,idx1) => {
                    if (this.form.countryId == item1.area_id) {
                      this.form.country = item1.area_name
                    }
                  });
                }
              }
            });
            attractInvestmentApi(this.form).then(({data})=>{
              this.$message.success('提交成功!')
              for (const key in this.form) {
                if (Object.hasOwnProperty.call(this.form, key)) {
                  this.form[key]=''
                }
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
  }
}
</script>
<style lang="scss">
@import './tojoin-write.scss';
</style>


// WEBPACK FOOTER //
// src/views/test-drive/tojoin/tojoin-write/tojoin-write.vue